import React from 'react';
import { useTheme } from '@mui/material/styles';
import type { ThemedSvgProps } from '../../types';

const BalloonBase: React.FC<ThemedSvgProps> = ({ color, size = 60, className }) => {
  const theme = useTheme();
  const fill = color || theme.palette.venue.kids;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      {/* Balloon body - oval, slightly taller than wide */}
      <ellipse cx="50" cy="38" rx="24" ry="30" fill={fill} />

      {/* Shine highlight on upper-left */}
      <ellipse cx="40" cy="28" rx="8" ry="10" fill="white" opacity={0.3} />

      {/* Knot at bottom */}
      <polygon points="50,68 46,72 54,72" fill={fill} />

      {/* Curved string */}
      <path
        d="M50 72 Q46 80 52 88 Q48 92 50 98"
        stroke={fill}
        strokeWidth="1.5"
        fill="none"
        opacity={0.6}
      />
    </svg>
  );
};

export const Balloon = React.memo(BalloonBase);
